/**
 * Changes an HTML attribute on the `<html>` element.
 * @param attribute - The name of the attribute to change.
 * @param value - The value to set for the specified attribute.
 * @returns A boolean indicating whether the operation was successful.
 */
const changeHTMLAttribute = (attribute: string, value: string): boolean => {
  if (!document.documentElement) return false

  document.documentElement.setAttribute(attribute, value)
  return true
}

export { changeHTMLAttribute }
